import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, vModelSelect as _vModelSelect, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-83120568"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row principal np" }
const _hoisted_2 = { class: "panelnp" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = {
  class: "paneltitle",
  style: {"padding":"0px"}
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "separator" }, null, -1))
const _hoisted_6 = {
  class: "row",
  style: {"display":"flex","align-items":"center"}
}
const _hoisted_7 = { class: "col-12" }
const _hoisted_8 = { class: "col-1" }
const _hoisted_9 = { class: "labeltitle" }
const _hoisted_10 = { class: "labeltitle" }
const _hoisted_11 = ["onKeyup"]
const _hoisted_12 = { class: "col-2" }
const _hoisted_13 = { class: "labeltitle" }
const _hoisted_14 = { class: "labeltitle" }
const _hoisted_15 = ["onKeyup"]
const _hoisted_16 = { class: "col-2" }
const _hoisted_17 = { class: "labeltitle" }
const _hoisted_18 = { class: "labeltitle" }
const _hoisted_19 = ["onKeyup"]
const _hoisted_20 = { class: "col-1" }
const _hoisted_21 = { class: "labeltitle" }
const _hoisted_22 = { class: "labeltitle" }
const _hoisted_23 = { class: "col-1" }
const _hoisted_24 = { class: "labeltitle" }
const _hoisted_25 = { class: "labeltitle" }
const _hoisted_26 = { class: "col-1" }
const _hoisted_27 = { class: "labeltitle" }
const _hoisted_28 = { class: "labeltitle" }
const _hoisted_29 = /*#__PURE__*/_createStaticVNode("<option value=\"\" selected data-v-83120568>ALL</option><option value=\"CR\" data-v-83120568>CR</option><option value=\"CT\" data-v-83120568>CT</option><option value=\"MR\" data-v-83120568>MR</option><option value=\"US\" data-v-83120568>US</option><option value=\"DX\" data-v-83120568>DX</option><option value=\"OT\" data-v-83120568>OT</option><option value=\"MG\" data-v-83120568>MG</option><option value=\"SR\" data-v-83120568>SR</option><option value=\"XA\" data-v-83120568>XA</option><option value=\"RF\" data-v-83120568>RF</option><option value=\"NM\" data-v-83120568>NM</option><option value=\"PT\" data-v-83120568>PT</option><option value=\"ECG\" data-v-83120568>ECG</option><option value=\"ES\" data-v-83120568>ES</option>", 15)
const _hoisted_44 = [
  _hoisted_29
]
const _hoisted_45 = { class: "col-1" }
const _hoisted_46 = { class: "labeltitle" }
const _hoisted_47 = { class: "labeltitle" }
const _hoisted_48 = ["onKeyup"]
const _hoisted_49 = {
  key: 0,
  class: "col-1"
}
const _hoisted_50 = { class: "labeltitle" }
const _hoisted_51 = { class: "labeltitle" }
const _hoisted_52 = ["onKeyup"]
const _hoisted_53 = { class: "col-1" }
const _hoisted_54 = { class: "labeltitle" }
const _hoisted_55 = { class: "labeltitle" }
const _hoisted_56 = /*#__PURE__*/_createStaticVNode("<option value=\"0\" data-v-83120568>ALL</option><option value=\"1\" data-v-83120568>Unread</option><option value=\"2\" data-v-83120568>Preliminary</option><option value=\"3\" data-v-83120568>Dictated</option><option value=\"4\" data-v-83120568>Transcribed</option><option value=\"5\" data-v-83120568>Final</option>", 6)
const _hoisted_62 = [
  _hoisted_56
]
const _hoisted_63 = /*#__PURE__*/_createStaticVNode("<option value=\"\" data-v-83120568>ALL</option><option value=\"SCHEDULED\" data-v-83120568>Scheduled</option><option value=\"INPROGRESS\" data-v-83120568>In Progress</option><option value=\"DISCONTINUED\" data-v-83120568>Discontinued</option><option value=\"COMPLETED\" data-v-83120568>Completed</option>", 5)
const _hoisted_68 = [
  _hoisted_63
]
const _hoisted_69 = { class: "row" }
const _hoisted_70 = {
  class: "col-12",
  style: {"padding-top":"5px"}
}
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-undo" }, null, -1))
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-clipboard-list" }, null, -1))
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "far fa-arrow-alt-circle-left" }, null, -1))
const _hoisted_74 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "far fa-calendar-check" }, null, -1))
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-search" }, null, -1))
const _hoisted_76 = /*#__PURE__*/_createStaticVNode("<div class=\"row\" data-v-83120568><div class=\"separator2\" data-v-83120568></div><div class=\"separator2\" data-v-83120568></div><div class=\"separator\" data-v-83120568></div><div class=\"separator\" data-v-83120568></div></div>", 1)

import { onMounted, ref } from "vue";
import { today, yesterday } from './common/routines';
import { Date2DICOM } from './common/routines';


export default /*#__PURE__*/_defineComponent({
  __name: 'SearchForm',
  props: ['worklist'],
  emits: ['query-data', 'pdf-list'],
  setup(__props, { emit: emits }) {

const props = __props;




var filter = ref({
  accession: "",
  patid: "",
  patname: "",
  dateFrom: "",
  dateTo: "",
  modality: "",
  description: "",
  institution: "",
  status: 0
});

var query = ref("");

function createQuery() {
  var previous = false;

  query.value = "";
  if (filter.value.accession.length > 0) {
    query.value = query.value + "?accession=" + filter.value.accession;
    previous = true;
  }
  if (filter.value.patid.length > 0) {
    if (previous) {
      query.value = query.value + "&patid=" + filter.value.patid;
    } else {
      query.value = query.value + "?patid=" + filter.value.patid;
      previous = true;
    }
  }
  if (filter.value.patname.length > 0) {
    if (previous) {
      query.value = query.value + "&patname=" + filter.value.patname;
    } else {
      query.value = query.value + "?patname=" + filter.value.patname;
      previous = true;
    }
  }
  var querydate = "";

  if (filter.value.dateFrom.length > 0) {
    const frdate = Date2DICOM(filter.value.dateFrom);
    querydate = "date=" + frdate + "-";
  }
  if (filter.value.dateTo.length > 0) {
    const todate = Date2DICOM(filter.value.dateTo);
    querydate = "date=" + "-" + todate;
  }
  if ((filter.value.dateFrom.length > 0) && (filter.value.dateTo.length > 0)) {
    const fromdate = Date2DICOM(filter.value.dateFrom);
    const todate = Date2DICOM(filter.value.dateTo);
    console.log("fromdate=" + fromdate + ", todate=" + todate);
    querydate = "date=" + fromdate + "-" + todate;
  }
  if (querydate != "") {
    if (previous) {
      query.value = query.value + "&" + querydate;
    } else {
      query.value = query.value + "?" + querydate;
      previous = true;
    }
    console.log("createQuery: ", querydate);
  }
  if (filter.value.modality.length > 0) {
    if (previous) {
      query.value = query.value + "&modality=" + filter.value.modality;
    } else {
      query.value = query.value + "?modality=" + filter.value.modality;
      previous = true;
    }
  }
  if (filter.value.description.length > 0) {
    if (previous) {
      query.value = query.value + "&description=" + filter.value.description;
    } else {
      query.value = query.value + "?description=" + filter.value.description;
      previous = true;
    }
  }
  if (filter.value.institution.length > 0) {
    if (previous) {
        query.value = query.value + "&institution=" + filter.value.institution;
    } else {
      query.value = query.value + "?institution=" + filter.value.institution;
      previous = true;
    }
  }

  //      console.log("createQuery: ", filter.value.status);
  if ((props.worklist) && (filter.value.status != 0)) {
    status = filter.value.status;
    if (previous) {
      query.value = query.value + "&status=" + status;
    } else {
      query.value = query.value + "?status=" + status;
      previous = true;
    }
  } else if (filter.value.status > 0) {
    var status = filter.value.status - 1;
    if (previous) {
      query.value = query.value + "&status=" + status;
    } else {
      query.value = query.value + "?status=" + status;
      previous = true;
    }
  }
  if (previous) {
    query.value = query.value + "&limit=200"
  } else {
    query.value = query.value + "?limit=200"
  }
  saveFormDataState();
}

function copyDate() {
  console.log("copyDate");
  filter.value.dateTo = filter.value.dateFrom;
}

function submitQuery() {
  createQuery();
  console.log("submitQuery: ", query.value);
  emits('query-data', query.value);
}

function queryYesterday() {
  filter.value.dateFrom = yesterday();
  filter.value.dateTo = yesterday();
  createQuery();
  emits('query-data', query.value);
}

function queryToday() {
  filter.value.dateFrom = today();
  filter.value.dateTo = today();
  createQuery();
  emits('query-data', query.value);
}

function resetQuery() {
  filter.value = {
    accession: "",
    patid: "",
    patname: "",
    dateFrom: "",
    dateTo: "",
    modality: "",
    description: "",
    institution: "",
    status: 0,
  };
  createQuery();
  emits('query-data', query.value);
}

function PDFlist() {
  createQuery();
  emits('pdf-list', query.value);
}

function initFormDataState() {
  const storage = sessionStorage.getItem('formData');
  if (storage != null) {
    const formData = JSON.parse(storage || '');
    console.log("SearchForm, formData: ", formData);
    if (formData) {
      filter.value = formData;
    }
  }
}

function saveFormDataState() {
  const formData = JSON.stringify(filter.value);
  sessionStorage.setItem('formData', formData);
}

onMounted(() => {
  initFormDataState();
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t("SearchForm.StudySearch")), 1),
          _hoisted_5
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.$t("Study.AccessionNumber")), 1),
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(filter).accession) = $event)),
                  onKeyup: _withKeys(submitQuery, ["enter"])
                }, null, 40, _hoisted_11), [
                  [_vModelText, _unref(filter).accession]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.$t("Study.ID")), 1),
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(filter).patid) = $event)),
                  onKeyup: _withKeys(submitQuery, ["enter"])
                }, null, 40, _hoisted_15), [
                  [_vModelText, _unref(filter).patid]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.$t("Study.Name")), 1),
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(filter).patname) = $event)),
                  onKeyup: _withKeys(submitQuery, ["enter"])
                }, null, 40, _hoisted_19), [
                  [_vModelText, _unref(filter).patname]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.$t("SearchForm.DateFrom")), 1),
                _withDirectives(_createElementVNode("input", {
                  type: "date",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(filter).dateFrom) = $event)),
                  onChange: copyDate
                }, null, 544), [
                  [_vModelText, _unref(filter).dateFrom]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("div", _hoisted_25, _toDisplayString(_ctx.$t("SearchForm.DateTo")), 1),
                _withDirectives(_createElementVNode("input", {
                  type: "date",
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(filter).dateTo) = $event))
                }, null, 512), [
                  [_vModelText, _unref(filter).dateTo]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("div", _hoisted_27, [
                _createElementVNode("div", _hoisted_28, _toDisplayString(_ctx.$t("Study.Modality")), 1),
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(filter).modality) = $event))
                }, _hoisted_44, 512), [
                  [_vModelSelect, _unref(filter).modality]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_45, [
              _createElementVNode("div", _hoisted_46, [
                _createElementVNode("div", _hoisted_47, _toDisplayString(_ctx.$t("Study.Description")), 1),
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  name: "StudyDescription",
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(filter).description) = $event)),
                  onKeyup: _withKeys(submitQuery, ["enter"])
                }, null, 40, _hoisted_48), [
                  [_vModelText, _unref(filter).description]
                ])
              ])
            ]),
            (!__props.worklist)
              ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                  _createElementVNode("div", _hoisted_50, [
                    _createElementVNode("div", _hoisted_51, _toDisplayString(_ctx.$t("Study.Institution")), 1),
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      name: "InstitutionName",
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(filter).institution) = $event)),
                      onKeyup: _withKeys(submitQuery, ["enter"])
                    }, null, 40, _hoisted_52), [
                      [_vModelText, _unref(filter).institution]
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_53, [
              _createElementVNode("div", _hoisted_54, [
                _createElementVNode("div", _hoisted_55, _toDisplayString(_ctx.$t("Study.Status")), 1),
                (!__props.worklist)
                  ? _withDirectives((_openBlock(), _createElementBlock("select", {
                      key: 0,
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_unref(filter).status) = $event))
                    }, _hoisted_62, 512)), [
                      [_vModelSelect, _unref(filter).status]
                    ])
                  : _createCommentVNode("", true),
                (__props.worklist)
                  ? _withDirectives((_openBlock(), _createElementBlock("select", {
                      key: 1,
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_unref(filter).status) = $event))
                    }, _hoisted_68, 512)), [
                      [_vModelSelect, _unref(filter).status]
                    ])
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_69, [
          _createElementVNode("div", _hoisted_70, [
            _createElementVNode("button", {
              class: "cnlbtn",
              onClick: resetQuery
            }, [
              _hoisted_71,
              _createTextVNode("Reset ")
            ]),
            _createElementVNode("button", {
              class: "okbtn",
              onClick: PDFlist
            }, [
              _hoisted_72,
              _createTextVNode(" PDF List ")
            ]),
            _createElementVNode("button", {
              class: "okbtn",
              onClick: queryYesterday
            }, [
              _hoisted_73,
              _createTextVNode(_toDisplayString(_ctx.$t("SearchForm.Yesterday")), 1)
            ]),
            _createElementVNode("button", {
              class: "okbtn",
              onClick: queryToday
            }, [
              _hoisted_74,
              _createTextVNode(_toDisplayString(_ctx.$t("SearchForm.Today")), 1)
            ]),
            _createElementVNode("button", {
              class: "okbtn",
              onClick: submitQuery
            }, [
              _hoisted_75,
              _createTextVNode(_toDisplayString(_ctx.$t("SearchForm.Submit")), 1)
            ])
          ])
        ])
      ])
    ]),
    _hoisted_76
  ], 64))
}
}

})